import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../utils/api.types";
import { AInvoiceSliceState } from "../../utils/invoice.types";
import { AReportSliceState } from "../../utils/report.types";
import { 
    fetchReport, 
    fetchPartyLedgerReport, 
    downloadPartyLedgerReport,
    fetchTdsPayableReport,
    fetchTdsReceivableReport,
    fetchTcsPayableReport,
    fetchTcsReceivableReport
} from "./reportThunk";

/**
 * Report slice initial state.
 */
const initialState: AReportSliceState = {
    reportsData: [],
    errorMessage: '',
    status: ApiStatus.IDLE
}

/**
 * Report Slice.
*/
const reportSlice = createSlice({
    name: 'report',
    initialState: initialState,
    reducers: {
        clearReportsData: (state) => {
            state.reportsData = [];
            state.status = ApiStatus.IDLE;
            state.errorMessage = '';
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch Reports
            .addCase(fetchReport.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchReport.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.reportsData = action?.payload.reportData || [];
                state.errorMessage = '';
            })
            .addCase(fetchReport.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })
            // Fetch fetchPartyLedgerReport
            .addCase(fetchPartyLedgerReport.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchPartyLedgerReport.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.errorMessage = '';
            })
            .addCase(fetchPartyLedgerReport.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })
            // Fetch fetchPartyLedgerReport
            .addCase(downloadPartyLedgerReport.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(downloadPartyLedgerReport.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.errorMessage = '';
            })
            .addCase(downloadPartyLedgerReport.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })
            // TDS Payable Report
            .addCase(fetchTdsPayableReport.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchTdsPayableReport.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.reportsData = action?.payload.reportData || [];
                state.errorMessage = '';
            })
            .addCase(fetchTdsPayableReport.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })
            // TDS Receivable Report
            .addCase(fetchTdsReceivableReport.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchTdsReceivableReport.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.reportsData = action?.payload.reportData || [];
                state.errorMessage = '';
            })
            .addCase(fetchTdsReceivableReport.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })
            // TCS Payable Report
            .addCase(fetchTcsPayableReport.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchTcsPayableReport.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.reportsData = action?.payload.reportData || [];
                state.errorMessage = '';
            })
            .addCase(fetchTcsPayableReport.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })
            // TCS Receivable Report
            .addCase(fetchTcsReceivableReport.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchTcsReceivableReport.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.reportsData = action?.payload.reportData || [];
                state.errorMessage = '';
            })
            .addCase(fetchTcsReceivableReport.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })
    }
});

export const { clearReportsData } = reportSlice.actions;
export default reportSlice.reducer;
